import { createRoot } from 'react-dom/client';

// The handoff, product bootstrap and recoverable error share one React root.
export const appRoot = createRoot(document.getElementById('root')!);
